// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.zKoY_cqRaA6c4A {
  display: flex;
  flex-wrap: wrap;
}
.kR_Yf2FgBWqXKZ {
  flex: 1 1 100%;
  margin-bottom: var(--ds-space-100, 8px);
}
.efGVRtznBLf9Aq {
  flex: 2.5;
  margin-right: var(--ds-space-100, 8px);
  margin-bottom: var(--ds-space-100, 8px);
}
.YEKBU2xiDAEwGT {
  flex: 1;
  margin-bottom: var(--ds-space-100, 8px);
}
.xSKyLTb9LueUMo {
  border-radius: var(--ds-border-radius-100, 3px);
  background-color: var(--ds-surface, #ffffff);
  background-repeat: no-repeat;
  cursor: progress;
  background-origin: border-box;
  animation-name: R5c1a9EKQGuSUn;
  animation-duration: 1.5s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  width: 60px;
  height: 20px;
  margin-top: var(--ds-space-050, 4px);
  margin-bottom: var(--ds-space-025, 2px);
}
@keyframes R5c1a9EKQGuSUn {
  from {
    background-color: var(--ds-skeleton, #091e420f);
  }
  to {
    background-color: var(--ds-skeleton-subtle, #091e4208);
  }
}
@media (prefers-reduced-motion: reduce) {
  .xSKyLTb9LueUMo {
    animation: none;
  }
}
.rTOvKD6XykwoZx {
  border-radius: var(--ds-border-radius-100, 3px);
  background-color: var(--ds-surface, #ffffff);
  background-repeat: no-repeat;
  cursor: progress;
  background-origin: border-box;
  animation-name: R5c1a9EKQGuSUn;
  animation-duration: 1.5s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  height: 36px;
}
@keyframes R5c1a9EKQGuSUn {
  from {
    background-color: var(--ds-skeleton, #091e420f);
  }
  to {
    background-color: var(--ds-skeleton-subtle, #091e4208);
  }
}
@media (prefers-reduced-motion: reduce) {
  .rTOvKD6XykwoZx {
    animation: none;
  }
}
.jenzizb1a78d2O {
  border-radius: var(--ds-border-radius-100, 3px);
  background-color: var(--ds-surface, #ffffff);
  background-repeat: no-repeat;
  cursor: progress;
  background-origin: border-box;
  animation-name: R5c1a9EKQGuSUn;
  animation-duration: 1.5s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  width: 26px;
  height: 20px;
  margin-top: var(--ds-space-100, 8px);
  padding: var(--ds-space-075, 6px) var(--ds-space-300, 24px);
}
@keyframes R5c1a9EKQGuSUn {
  from {
    background-color: var(--ds-skeleton, #091e420f);
  }
  to {
    background-color: var(--ds-skeleton-subtle, #091e4208);
  }
}
@media (prefers-reduced-motion: reduce) {
  .jenzizb1a78d2O {
    animation: none;
  }
}
.vLrVSE7NIMRvMx {
  border-radius: var(--ds-border-radius-100, 3px);
  background-color: var(--ds-surface, #ffffff);
  background-repeat: no-repeat;
  cursor: progress;
  background-origin: border-box;
  animation-name: R5c1a9EKQGuSUn;
  animation-duration: 1.5s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  width: 120px;
  height: 16px;
  margin-top: var(--ds-space-200, 16px);
  margin-bottom: var(--ds-space-100, 8px);
}
@keyframes R5c1a9EKQGuSUn {
  from {
    background-color: var(--ds-skeleton, #091e420f);
  }
  to {
    background-color: var(--ds-skeleton-subtle, #091e4208);
  }
}
@media (prefers-reduced-motion: reduce) {
  .vLrVSE7NIMRvMx {
    animation: none;
  }
}
`, ""]);
// Exports
export var skeletonSelectContainer = `zKoY_cqRaA6c4A`;
export var skeletonBoardContainer = `kR_Yf2FgBWqXKZ`;
export var skeletonListContainer = `efGVRtznBLf9Aq`;
export var skeletonPositionContainer = `YEKBU2xiDAEwGT`;
export var skeletonSelectLabel = `xSKyLTb9LueUMo`;
export var shimmer = `R5c1a9EKQGuSUn`;
export var skeletonSelectBox = `rTOvKD6XykwoZx`;
export var skeletonButton = `jenzizb1a78d2O`;
export var skeletonHeaderText = `vLrVSE7NIMRvMx`;
export default ___CSS_LOADER_EXPORT___;
